'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import { useState, FC } from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { NavigationItemLevel2 } from '../types';
import { navbarLinkToUrl } from '../utils/utils';
import SidebarLink from './SidebarLink';

interface SidebarGroupProps {
  pushDataLayer: PushDataLayerFn;
}

const SidebarGroup: FC<SidebarGroupProps & NavigationItemLevel2> = (props) => {
  const { langPrefix, brand } = useCmsClientContext();
  const { sublinks = [], pushDataLayer, ...rest } = props;
  const [isOpen, setIsOpen] = useState(false);

  const { text, href, url_target } = navbarLinkToUrl(rest, {
    langPrefix,
    brand,
  });

  const toggleGroup = () => setIsOpen(!isOpen);

  return (
    <div>
      {sublinks!.length > 0 ? (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          onClick={toggleGroup}
          className="flex cursor-pointer items-center justify-between px-4 py-5 bg-[#EDF6FF]"
        >
          <h3 className="font-bold text-[#212529] text-[16px]">{text}</h3>
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            className={isOpen ? 'rotate-180' : 'rotate-0'}
            viewBox="0 0 448 512"
            width="10"
            height="10"
            aria-hidden="true"
          >
            <path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" />
          </svg>
        </div>
      ) : (
        <FeLink
          href={href}
          target={url_target}
          className="flex cursor-pointer items-center justify-between px-4 py-5 font-bold bg-[#EDF6FF] text-[#212529] alpha-body-2"
        >
          {text}
        </FeLink>
      )}
      {isOpen && (
        <ul>
          {sublinks!.map((sublink, index) => {
            const subUrl = navbarLinkToUrl(sublink!, { langPrefix, brand });
            if (!subUrl.href) {
              return null;
            }
            return (
              <li key={`${subUrl.text}_${subUrl.href}`} className="mt-1">
                <SidebarLink
                  index={index}
                  sectionTitle={text}
                  pushDataLayer={pushDataLayer}
                  {...sublink!}
                />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SidebarGroup;
